/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types -- needed */
// List view is currently not being used on benefits dashboard.
// TODO: Potential to deprecate this code.
import React from 'react';
import PropTypes from 'prop-types';
import { Surface } from '@americanexpress/dls-react';

const ListLayout = ({ children, searching }) => {
  if (!children) {
    throw new Error('This layout expects children');
  }
  return (
    <>
      <Surface
        variant="foreground"
        className={`row margin-0-lr pad-2-sm-up pad-3-lg-up border radius-container-sm ${searching === true ? 'margin-1-b' : 'margin-2-b margin-3-b-lg-up'}`}
      >
        <div className="flex flex-column col-xs-12 col-md-5 col-lg-3 stack pad-0-lr">
          {React.cloneElement(children[0], {
            imgUrl: children[0].props.imageUrl,
            title: children[0].props.benefitTitle,
            width: '',
            height: '100%',
          })}
        </div>
        <div className="pad-2-xs-down pad-0-lr flex flex-column col-xs-12 col-md-7 col-lg-9">
          <div className="pad-0">
            {children[1]}
            {children[2]}
          </div>
        </div>
      </Surface>
      {searching === true ? '' : <hr />}
    </>
  );
};

ListLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ListLayout;
